import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Client-side navigasyonda tarayici otomatik kaydirma yapmaz.
// Hash varsa ilgili bolume, yoksa sayfa basina goturur.
const ScrollToHash = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const target = document.getElementById(hash.slice(1));
            if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
                return;
            }
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};

export default ScrollToHash;
